import { IServiceProvider } from "@/models/serviceprovider";
import { IRootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

export interface IServiceProviderState {
    serviceProvidersList: IServiceProvider[] | null;
    selectedServiceProvider: IServiceProvider | null;
    isSelectedServiceProvider: boolean;
    error: any;
}

export const getDefaultSPState = (): IServiceProviderState => {
    return {
        serviceProvidersList: [],
        selectedServiceProvider: null,
        isSelectedServiceProvider: false,
        error: null,
    };
};

// initial state
const state = getDefaultSPState();

const namespaced: boolean = true;

export const serviceProviders: Module<IServiceProviderState, IRootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
